import React from 'react';
import Modal, { ModalFooter, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { Error } from '../contexts/Error';

interface ShowPromptProperties {
  error?: Error;
  onClose: () => void;
}
const getPrompt = (onClose: () => void, error?: Error): JSX.Element | null => {
  if (!error) return null;
  const { title, text, btnText } = error;
  const footer = (
    <ModalFooter>
      <Button text={btnText} type="primary" onClick={onClose} />
    </ModalFooter>
  );
  return (
    <Prompt title={title} footer={footer}>
      <p>{text}</p>
    </Prompt>
  );
};

export const ShowErrorItem: React.FC<ShowPromptProperties> = ({
  error,
  onClose,
}) => {
  return (
    <Modal visible={!!error} escapable={false} handleCloseBtn={onClose}>
      {getPrompt(onClose, error)}
    </Modal>
  );
};
